import { TransactionType } from 'api/transactions/dtos'

const INCOMING_REQUIRED = [
	TransactionType.CRYPTO_FORK,
	TransactionType.CURRENCY_MARGIN_PROFIT,
	TransactionType.CRYPTO_BORROWING,
	TransactionType.CRYPTO_STAKING_REWARD,
	TransactionType.CRYPTO_INCOME_REWARD,
	TransactionType.CRYPTO_INTEREST_INCOME,
	TransactionType.CRYPTO_ICO_IDO,
	TransactionType.CRYPTO_RECEIVE_GIFT_OR_DONATION,
	TransactionType.CRYPTO_RECEIVE_PAYMENT,
	TransactionType.CRYPTO_MINING,
	TransactionType.CRYPTO_AIRDROP,
	TransactionType.CRYPTO_SPAM,
	TransactionType.CRYPTO_RECEIVE_NON_TAXABLE,
	TransactionType.FIAT_DEPOSIT,
	TransactionType.CRYPTO_LIQUIDITY_POOL_WITHDRAWAL,
	TransactionType.CRYPTO_LIQUIDITY_POOL_DEPOSIT,
	TransactionType.CRYPTO_NON_TAXABLE_SWAP,
	TransactionType.CRYPTO_MINTED_SELL,
	TransactionType.CRYPTO_LENDING_REPAYMENT,
	TransactionType.CRYPTO_LENDING,
	TransactionType.FIAT_TRADE,
	TransactionType.CRYPTO_TRADE,
	TransactionType.CRYPTO_SELL_FOR_FIAT,
	TransactionType.CRYPTO_PURCHASE_FOR_FIAT,
]
const OUTGOING_REQUIRED = [
	TransactionType.CURRENCY_MARGIN_LOSS,
	TransactionType.CRYPTO_TRANSFER,
	TransactionType.CRYPTO_OTHER_FEES,
	TransactionType.CRYPTO_DEBT_REPAYMENT,
	TransactionType.CRYPTO_EXPENSE,
	TransactionType.CRYPTO_LOST_OR_STOLEN,
	TransactionType.CRYPTO_SEND_NON_TAXABLE,
	TransactionType.CRYPTO_SEND_GIFT_OR_DONATION,
	TransactionType.CRYPTO_SEND_PAYMENT,
	TransactionType.CRYPTO_SEND_TO_UNKNOWN,
	TransactionType.FIAT_WITHDRAWAL,
	TransactionType.CRYPTO_LIQUIDITY_POOL_WITHDRAWAL,
	TransactionType.CRYPTO_LIQUIDITY_POOL_DEPOSIT,
	TransactionType.CRYPTO_NON_TAXABLE_SWAP,
	TransactionType.CRYPTO_MINTED_SELL,
	TransactionType.CRYPTO_LENDING_REPAYMENT,
	TransactionType.CRYPTO_LENDING,
	TransactionType.FIAT_TRADE,
	TransactionType.CRYPTO_TRADE,
	TransactionType.CRYPTO_SELL_FOR_FIAT,
	TransactionType.CRYPTO_PURCHASE_FOR_FIAT,
	TransactionType.CRYPTO_LIQUIDATION,
]

export const isTransactionRequiredFieldByDirection = (type: TransactionType, direction: 'incoming' | 'outgoing') =>
	direction === 'incoming' ? INCOMING_REQUIRED.includes(type) : OUTGOING_REQUIRED.includes(type)
